import {
  CONSUMER_CMS_SHOPPING_CART,
  IPersonalInfoCmsMobile,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import { API } from '@vfit/shared/data-access';
import { useTracking } from '@vfit/shared/data-access';
import { ListCard } from '@vfit/consumer/components';
import { organizeRecognitionSimVideoRecognition } from './recognitionSimVideoRecognition.utils';
import { getUserInfo, getTagging, isEsim } from '../../../../checkout.utils';
import { IRecognitionSimVideoRecognition } from './recognitionSimVideoRecognition.models';
import { useCheckout } from '../../../../../iBuyMobile.context';
import { useQueryClient } from 'react-query';

const RecognitionSimVideoRecognition = ({ isMNP }: IRecognitionSimVideoRecognition) => {
  const queryClient = useQueryClient();

  const { simOptions } = useCheckout();

  const selectedSimOption = simOptions.simOptions.find((simOption) => simOption.selection);
  const isEsimValue = isEsim(selectedSimOption) || false;

  const dataFromCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PERSONAL_DATA_MOBILE
  ) as IPersonalInfoCmsMobile;
  const dataRecognitionSimVideoRecognition = organizeRecognitionSimVideoRecognition(
    dataFromCms,
    isEsimValue
  );

  const list = {
    title: dataRecognitionSimVideoRecognition.list.title,
    items: isMNP
      ? dataRecognitionSimVideoRecognition.list.portabilityItems
      : dataRecognitionSimVideoRecognition.list.items,
  };

  const taggingMobile = getTagging(isMNP ? 'mnp' : 'new sim', 'mobile', queryClient);

  useTracking({
    event: ['checkout_step4.8'],
    event_label: 'VR: Video Recognition',
    opts: { ...taggingMobile?.opts, page_subsection: isEsimValue ? 'e-sim' : 'sim fisica' },
    cartProduct: taggingMobile?.trackingProduct,
    pageProduct: taggingMobile?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });

  return <ListCard data={dataRecognitionSimVideoRecognition.data} list={list} />;
};

export default RecognitionSimVideoRecognition;
